export type RetrieveRoleResponse = {
  id: string
  name: string
  permissions: Array<string>
}

export const retrieveRole = async (id: string) => {
  const { body } = await api.get<RetrieveRoleResponse>(
    `/users/roles/${id}/`
  )
  return body
}
